// extracted by mini-css-extract-plugin
export var closeButton = "styles-module--closeButton--a098c";
export var content = "styles-module--content--40c52";
export var notTranslatedInfoBox = "styles-module--notTranslatedInfoBox--bb6a1";
export var notTranslatedInfoBox_hidden = "styles-module--notTranslatedInfoBox_hidden--cc2d6";